




















































import { doLogin } from "@/services/login.service";
import axios from "axios";

export default {
  data() {
    return {
      formEmail: "",
      formLang: "de-DE",
      formPwd: "",
      error: false,
      errorMessage: "",
      langs: [
        { state: "Deutsch", abbr: "de-DE" },
        { state: "English", abbr: "en-EN" },
      ],
    };
  },
  watch: {
    formLang: function (val) {
      if (val == "de-DE") {
        this.$i18n.locale = val;
      } else {
        this.$i18n.locale = "en-EN";
      }
    },
  },

  methods: {
    login: function () {
      this.error = false;

      this.$store.commit("auth_request");

      doLogin({ email: this.formEmail, password: this.formPwd, lang: this.$i18n.locale }).then((x) => {
        console.log(x);
        if (x.status == "error") {
          this.error = true;
          this.errorMessage = x.message;
          this.$store.commit("auth_error");
          localStorage.removeItem("token");
        } else {
          const token = x.data.token;
          const user = x.data.user;
          const role = x.data.role;
          const company_id = x.data.company_id;

          this.$store.state.user_role = role;
          localStorage.setItem("user_role", JSON.stringify(role));
          this.$store.state.company_id = company_id;
          localStorage.setItem("company_id", company_id);

          this.$store.state.lang = this.formLang
          axios.defaults.headers.common['x-lang'] = this.$store.state.lang


          localStorage.setItem("lang", this.formLang);

          localStorage.setItem("token", token);
          axios.defaults.headers.common["x-access-token"] = token;
          this.$store.commit("auth_success", { token, user });
          this.$router.push({ name: "overview" });
        }
      });
    },
    keyUp: function (ev) {
      if (ev.keyCode == 13) {
        this.login();
      }
    },
  },
  mounted() {},
};
